import React from 'react';
import { Navigate } from 'react-router-dom';

interface RedirectToProps {
  redirectCondition: boolean;
  redirectRoute: string;
  children?: React.ReactNode;
}

const RedirectTo: React.FC<RedirectToProps> = ({
  redirectCondition,
  redirectRoute,
  children,
}) => {
  return (
    <>
      {redirectCondition ? (
        <Navigate to={redirectRoute} replace={true} />
      ) : (
        children
      )}
    </>
  );
};

export default RedirectTo;
